/**
* Locations Grid JS
* -----------------------------------------------------------------------------
*
* All the JS for the Locations Grid component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'locations-grid',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      // function to allow .remove() to work for removing open popups in createPopup()
      if ( !( 'remove' in Element.prototype ) ) {
        Element.prototype.remove = function() {
          if ( this.parentNode ) {
            this.parentNode.removeChild( this );
          }
        };
      }
      // mapKey variable is set in the PHP file
      mapboxgl.accessToken = llMapbox.token;

      $( '.locations-grid .map' ).each( function() {
        const mapLocations = $( this ).data( 'locations' );
        // unique id to render map in
        const mapId = $( this ).attr( 'id' );
        const mapInfo = {
          coordinates: {
            lat: $( this ).data( 'lat' ),
            long: $( this ).data( 'long' ),
          },
        };
        loadMap( mapInfo, mapId );
      } );

      function loadMap( mapInfo, mapId ) {
        const place = {
          type: 'Feature',
          properties: {
            id: mapId,
          },
          geometry: {
            type: 'Point',
            coordinates: [parseFloat( mapInfo.coordinates.long ), parseFloat( mapInfo.coordinates.lat )],
          },
        };

        const offsetLat = parseFloat( place.geometry.coordinates[1] ) + 0.001;
        const center = [place.geometry.coordinates[0], offsetLat];

        const map = new mapboxgl.Map( {
          container: mapId, // mounts on the elements current id
          style: llMapbox.style, // stylesheet URL set in PHP file
          center: center,
          zoom: 15,
          zoomControl: false,
        } );

        // add locations from the places array to the map
        // and create the markers
        // and add the map navigations controls
        map.on( 'load', () => {
          // add this "geojson" object to the map, passing in the places array
          map.addSource( 'points', {
            type: 'geojson',
            data: {
              type: 'FeatureCollection',
              features: [place],
            },
          } );

          addMarkers( [place], map );
        } );
      }

      function addMarkers( locations, map ) {
        locations.forEach( function( marker, i ) {
          const el = document.createElement( 'div' );
          /* Assign a unique `id` to the marker. */
          el.id = 'marker-' + marker.properties.id;
          /* Assign the `marker` class to each marker for styling. */
          el.className = 'marker';
          // you can add you svg here through js or set is as background image or whichever you prefer. Anything can be used as a marker in this situation.

          /**
           * Create a marker using the div element
           * defined above and add it to the map.
           **/
          new mapboxgl.Marker( el, {offset: [0, -23]} )
              .setLngLat( marker.geometry.coordinates )
              .addTo( map );
        } );
      }
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'locations-grid', COMPONENT );
} )( app );
